"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _attach = _interopRequireDefault(require("./attach"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _reactMarkdown = _interopRequireDefault(require("react-markdown"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Text = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(Text, _React$PureComponent);

  var _super = _createSuper(Text);

  function Text() {
    (0, _classCallCheck2.default)(this, Text);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Text, [{
    key: "render",
    value: function render() {
      var text = this.props.text; // We use component=div to force usage of a div, instead of a p, as properly formatted HTML
      // cannot nest tags like h1 under a <p>.

      return /*#__PURE__*/_react.default.createElement(_Typography.default, {
        component: "div"
      }, /*#__PURE__*/_react.default.createElement(_reactMarkdown.default, {
        source: text
      }));
    }
  }]);
  return Text;
}(_react.default.PureComponent);

Text = (0, _attach.default)(['text'])(Text);
var _default = Text;
exports.default = _default;